import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { activateNewWorkspaceUser } from '../../../services/Users';
import { DEFAULT_PASSWORD_POLICY, getClientParametersByToken } from '../../../services/PasswordPolicies';

import { useAppContext } from '../../../contexts/app';

const useUserActivation = (token) => {
  const navigateRedirect = useNavigate();
  const { blockScreen, handleAlert } = useAppContext();
  const [passwordPolicies, setPasswordPolicies] = useState(DEFAULT_PASSWORD_POLICY);

  const formMethods = useForm({
    defaultValues: {
      token,
      password: '',
      newPassword: '',
      firstName: '',
      lastName: '',
      mobile: '',
      areaActivity: '',
      position: '',
    },
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => formMethods.reset(), []);

  const handleHome = () => navigateRedirect('/');

  useEffect(() => {
    const initComponent = async () => {
      blockScreen(true);
      try {
        const params = await getClientParametersByToken(token);
        setPasswordPolicies({
          ...DEFAULT_PASSWORD_POLICY,
          ...params,
        });
      } catch (error) {
        handleAlert(error, 'error');
      } finally {
        blockScreen(false);
      }
    };

    initComponent();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnSubmit = (data) => {
    blockScreen(true);
    Promise.all([activateNewWorkspaceUser(data)]).then(() => {
      formMethods.reset();
      blockScreen(false);
      handleAlert('User activated succefully!', 'success');
      setTimeout(() => {
        handleHome();
      }, 1000);
    }).catch((error) => {
      handleAlert(error, 'error');
      blockScreen(false);
    });
  };

  return {
    formMethods,
    passwordPolicies,
    handleHome,
    handleOnSubmit,
  };
};

export default useUserActivation;
